/**
 * Created by normann.lou on 17/08/2017.
 */
;(function ($) {
  "use strict";

  function initAddToCal() {
    $("#global-modal").on("click", ".calendar-add-actions button", function (e) {
      e.preventDefault();
      window.open($(e.target).data("href"), "_blank");
    });
  }

  $(document).ready(function () {
    initAddToCal();
  });
}(jQuery));
